module.exports = __webpack_public_path__ + "img/people-group-solid 1.11a1c03a.svg";